import { AddViewSupport49Container } from "../../../containers/SupportSystem/ViewReports/AddViewSupport49Container"
export function AddViewSupport49Page() {
    return (
        <AddViewSupport49Container />
    )
}